// Components
import { StepMediaVideoCompleteComponent } from './step-media-video-complete.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_MEDIA_VIDEO_COMPLETE = {
  stepIdentifier: 'mediaUploadFlowStepVideoComplete',
  identifier: 'uploadVideoComplete',
  component: StepMediaVideoCompleteComponent,
  name: 'Review',
  title: 'Your verified content is ready',
  subtitle: 'Download your signed copy and publish your image.',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
} as MediaUploadFlowStep;
